export enum StatsElementViewGridBlock {
  Root = 'StatsElementViewGrid',
}

export enum StatsElementViewGridElement {
  Grid = 'grid',
}
